import React from 'react';

export const xPortal = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    height='30'
    viewBox='0 0 17.5 28'
    className='app-icon xportal-app'
  >
    <defs></defs>
    <g transform='translate(11007 -18884.001)'>
      <path
        className='cls-mobile-wallet-1'
        fill='#fff'
        d='M14.875-21H2.625A2.626,2.626,0,0,0,0-18.375V4.375A2.626,2.626,0,0,0,2.625,7h12.25A2.626,2.626,0,0,0,17.5,4.375v-22.75A2.626,2.626,0,0,0,14.875-21Z'
        transform='translate(-11007 18905)'
      ></path>
      <g transform='translate(-11003 18892.168) scale(0.285)'>
        <path d='M17.8956 12.0018L32.0458 4.52327L29.6668 0L16.7098 5.18441C16.3761 5.31809 16.0062 5.31809 15.6726 5.18441L2.71192 0L0.333008 4.52327L14.4832 12.0018L0.333008 19.4767L2.71192 24L15.669 18.8156C16.0027 18.6819 16.3725 18.6819 16.7061 18.8156L29.6632 24L32.0421 19.4767L17.8919 11.9982L17.8956 12.0018Z'></path>
      </g>
      <circle
        className='cls-mobile-wallet-2'
        cx='1.5'
        cy='1.5'
        r='1.5'
        transform='translate(-10999.75 18906.498)'
      ></circle>
    </g>
  </svg>
);
